import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductReveal() {
  return <section className="bg-white py-20 px-4" data-id="element-171">
      <div className="max-w-3xl mx-auto" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-173">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-6" data-id="element-174">
            Por eso creé este plan
          </h2>
          <p className="text-lg md:text-xl text-[#2D2A26] leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-175">
            Este PDF se llama{' '}
            <span className="font-bold" data-id="element-176">“$56 Más No Te Salva”</span> porque esa
            es la mentira que nos venden: “Si te suben un poquito el cheque, ya
            estás bien.”
          </p>
          <p className="text-lg md:text-xl text-[#2D2A26] leading-relaxed max-w-2xl mx-auto" data-id="element-177">
            Pero tú y yo sabemos la verdad: si no hay un sistema, el mes se lo
            traga igual.
          </p>
        </motion.div>

        <div className="bg-[#FAF7F2] p-8 md:p-12 rounded-2xl border-2 border-[#1B2A4A]/10 shadow-lg mb-12" data-id="element-178">
          <h3 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-179">
            Un plan de 14 días, con letra clara y pasos cortos, para que
            instales:
          </h3>

          <ul className="space-y-6" data-id="element-180">
            {['Sistema 3 Sobres (Cuentas / Comida / Medicinas)', 'Calendario de Pagos Anti-Cargos (para pagar lo que más castiga, antes)', '5 Cortes Silenciosos (recortes que no se sienten como castigo)'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="flex items-start gap-4" data-id="element-181">
                <CheckCircle2 className="w-8 h-8 text-[#C94040] flex-shrink-0 mt-1" data-id="element-182" />
                <span className="text-lg md:text-xl font-medium text-[#2D2A26]" data-id="element-183">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-184">
          <CTAButton data-id="element-185">EMPEZAR EL DÍA 1 HOY</CTAButton>
        </div>
      </div>
    </section>;
}